import { HttpClient } from '@angular/common/http';
import { Post } from '@app/shared/models/post';
import { environment } from '@env/environment';
import { isUndefined, omitBy } from 'lodash';
import { Observable } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ApiClientConfig } from '../api-client.config';
import {
  GetPinnedPostResponse,
  GetSearchPostResponse,
  PinnedPostModel,
  PostArrayResponse,
  PostRequest,
  PostResponse,
  SearchPostParams
} from './api.post.model';

export class PostApi {
  private apiUrl = environment.API_URL;
  POST = '/posts/posts';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getPostsByUser(
    userId: string,
    pageNum: number,
    pageSize: number,
    isFriend: boolean,
    sortByDate: string
  ): Observable<Post[]> {
    return this.http
      .get<PostArrayResponse>(
        `${this.apiUrl}${this.POST}/user?pageNum=${pageNum}&pageSize=${pageSize}&userId=${userId}&isFriend=${isFriend}&sortByDate=${sortByDate}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: PostArrayResponse) => {
          return res.data;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }

  updatePost(post: PostRequest, id: string): Observable<Post> {
    post = omitBy(post, isUndefined);
    return this.http.put<PostResponse>(`${this.apiUrl}${this.POST}/${id}`, post).pipe(
      timeout(this.config.responseTimeout),
      map((res: PostResponse) => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  updateSharedPost(post: PostRequest, id: string): Observable<Post> {
    post = omitBy(post, isUndefined);
    return this.http.put<PostResponse>(`${this.apiUrl}${this.POST}/update-share/${id}`, post).pipe(
      timeout(this.config.responseTimeout),
      map((res: PostResponse) => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  getPostById(id: string): Observable<Post> {
    return this.http.get<PostResponse>(`${this.apiUrl}${this.POST}/${id}`).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  getPinnedPosts(): Observable<GetPinnedPostResponse> {
    return this.http.get<GetPinnedPostResponse>(`${this.apiUrl}/feeds-engine/pinned-posts`).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  searchPost(params: SearchPostParams): Observable<GetSearchPostResponse> {
    return this.http
      .get<GetSearchPostResponse>(`${this.apiUrl}${this.POST}/search`, {
        params: { ...params }
      })
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }

  pinnedPosts(body: PinnedPostModel[]): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/feeds-engine/pinned-posts`, body).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }
}
